module.exports = {
      id: "user-square-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#user-square",
      toString: function () {
        return this.url;
      }
    }